import { render, staticRenderFns } from "./GatewayDeleteScreen.vue?vue&type=template&id=6699ba53&scoped=true&lang=pug"
import script from "./GatewayDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./GatewayDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./GatewayDeleteScreen.vue?vue&type=style&index=0&id=6699ba53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6699ba53",
  null
  
)

export default component.exports